var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7527 9.52109L17.6127 8.01242C17.225 7.7391 16.6891 8.01742 16.6891 8.49133V9.41406H6.4141C6.09051 9.41406 5.82812 9.6764 5.82812 10C5.82812 10.3237 6.09051 10.586 6.4141 10.586H16.689V11.5087C16.689 11.9857 17.2278 12.2588 17.6126 11.9876L19.7526 10.4789C20.0794 10.2487 20.086 9.75656 19.7527 9.52109Z",
    fill: "#0061DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8153 13.7624C16.5352 13.6004 16.1767 13.6961 16.0146 13.9762C14.6382 16.3557 12.0653 17.9532 9.12512 17.9532C4.73973 17.9532 1.17191 14.3854 1.17191 10C1.17191 5.6146 4.73973 2.04679 9.12512 2.04679C12.0673 2.04679 14.639 3.64574 16.0146 6.02371C16.1766 6.30386 16.5352 6.39945 16.8152 6.23753C17.0954 6.0755 17.1911 5.71703 17.0291 5.43691C15.446 2.70027 12.4894 0.874878 9.12512 0.874878C4.08164 0.874878 0 4.95609 0 10C0 15.0435 4.08121 19.1251 9.12512 19.1251C12.4909 19.1251 15.4467 17.2984 17.0291 14.563C17.1911 14.2829 17.0954 13.9244 16.8153 13.7624Z",
    fill: "#0061DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.dd8ec9e5dbb05b11042c56aefa225140.svg";
export { ForwardRef as ReactComponent };